export const rootRoute = () => "/";
export const productsRoute = () => "/products";
export const productRoute = (slug) => `${productsRoute()}/${slug}`;
export const legalsRoute = () => "/legal";
